"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1875],{

/***/ 51875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FC": function() { return /* binding */ useBuyStyles; },
/* harmony export */   "hm": function() { return /* binding */ BuyOnePassSuccess; },
/* harmony export */   "xb": function() { return /* binding */ BuyOnePass; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(10253);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(14310);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(282);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(22318);
/* harmony import */ var _DescribeQuestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93867);
/* harmony import */ var _onboarding_OnboardingDesignWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4977);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31955);
/* harmony import */ var _pages_get_started__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98901);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(87066);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53056);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4465);
/* harmony import */ var _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66306);
/* harmony import */ var _utility_common__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5969);
/* harmony import */ var _utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89147);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14416);
/* harmony import */ var _utility_services_authActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63846);
























var useBuyStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(theme) {
    return {
        finalStepWrapper: {
            position: "absolute"
        },
        buyPassSuccessWrapper: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        buyBoxOuterHeader: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            paddingBottom: "16px"
        },
        subHeader: {
            overflow: "hidden",
            color: "#1D3557",
            textAlign: "center",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal"
        },
        buyPassNow: {
            borderRadius: "4.2px",
            background: "#FFC72C",
            boxShadow: "none",
            "&.MuiButton-containedPrimary:hover": {
                backgroundColor: "#FFC72C"
            }
        },
        conditions: {
            color: "#1D3557",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "108%"
        },
        orWait: {
            color: "#757575",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "normal",
            margin: "24px auto 8px"
        },
        willGet: {
            overflow: "hidden",
            color: "#757575",
            textAlign: "center",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: "Poppins",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal"
        },
        willWait: {
            borderRadius: "4.2px",
            border: "1px solid #757575",
            background: "#FFF",
            color: "#757575",
            textAlign: "center",
            fontFamily: '"Source Sans Pro"',
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "108%"
        },
        successActionBox: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
            background: "#F6F7F9",
            width: "679px",
            padding: "24px",
            alignItems: "center"
        }, theme.breakpoints.down("xs"), {
            width: "100%"
        }),
        celebrateImage: {
            width: "108.969px",
            height: "113.862px"
        },
        SpecialDiscount: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            position: "absolute",
            width: "135px",
            height: "11px",
            top: "5px",
            color: "#f25f5c",
            fontFamily: "Poppins, var(--default-font-family)",
            fontSize: "8px",
            fontWeight: 700,
            lineHeight: "11px",
            textAlign: "center",
            whiteSpace: "nowrap",
            zIndex: 3
        },
        strikethroughPrice: {
            position: "relative",
            color: "#979797",
            fontFamily: "Poppins, var(--default-font-family)",
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: "36px",
            textAlign: "center"
        },
        dividerTextOr: {
            padding: "10px 20px",
            color: "#1D3557",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700
        },
        dividerTextDescription: {
            color: "#1D3557",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 700
        }
    };
});
var BuyOnePass = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showRequestLoader = ref3[0], setShowRequestLoader = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), allPlanLinks = ref4[0], setAllPlanLinks = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({}), dayPassLink = ref5[0], setDayPassLink = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), nativeModel = ref6[0], setNativeModel = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isDirectBuyPassPage = ref7[0], setIsDirectBuyPassPage = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isToolUser = ref8[0], setIsToolUser = ref8[1];
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__/* .useSession */ .kP)().session;
    var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
    var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_auth");
    var questionStyles = (0,_DescribeQuestion__WEBPACK_IMPORTED_MODULE_2__/* .useQuestionsStyles */ .b)();
    var buyStyles = useBuyStyles();
    var signupStyles = (0,_pages_get_started__WEBPACK_IMPORTED_MODULE_6__.useSignUpStyles)();
    var onboardingStyles = (0,_onboarding_OnboardingDesignWrapper__WEBPACK_IMPORTED_MODULE_3__/* .useOnboardingStyles */ .M4)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var isMobile = (0,_utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_10__/* .useView */ .Pl)("mobileOnly", true);
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), timeLeft = ref9[0], setTimeLeft = ref9[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_15__.useDispatch)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var ref;
        if ((session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.userType) === _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .USER_CLASSIFICATION.QWA_TOOLS */ .Cf8.QWA_TOOLS) {
            setIsToolUser(true);
        }
        var timeoutId;
        var searchParams = window.parent.location.search;
        var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_auth");
        var qttr_tools_daypass_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_daypass_auth");
        if (!searchParams) {
            timeoutId = setTimeout(function() {
                var searchParams = window.parent.location.search;
                var queryParams = new URLSearchParams(searchParams);
                var isBuyPass = queryParams.get("buyPass");
                if (isBuyPass && qttr_tools_auth && !showRequestLoader && !qttr_tools_daypass_auth) {
                    setIsDirectBuyPassPage(true);
                // handleGetCheckoutPage();
                }
            }, 500);
        }
        var queryParams = new URLSearchParams(searchParams);
        var isBuyPass = queryParams.get("buyPass");
        if (isBuyPass && qttr_tools_auth && !showRequestLoader && !qttr_tools_daypass_auth) {
            setIsDirectBuyPassPage(true);
        // handleGetCheckoutPage();
        }
    }, []);
    //for paid tool timer that we are showing
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var calculateTimeUntilMidnight = function() {
            var now = new Date();
            var midnight = new Date();
            midnight.setHours(24, 0, 0, 0); // Set time to midnight
            return midnight.getTime() - now.getTime(); // Calculate difference in milliseconds
        };
        var formatTimeLeft = function(milliseconds) {
            var totalSeconds = Math.floor(milliseconds / 1000);
            var hours = Math.floor(totalSeconds / 3600);
            var minutes = Math.floor(totalSeconds % 3600 / 60);
            var seconds = totalSeconds % 60;
            return "".concat(hours.toString().padStart(2, "0"), "h ").concat(minutes.toString().padStart(2, "0"), "m ").concat(seconds.toString().padStart(2, "0"), "s");
        };
        var scheduleMidnightFunction = function() {
            var timeUntilMidnight = calculateTimeUntilMidnight();
            setTimeLeft(formatTimeLeft(timeUntilMidnight));
            var countdownInterval = setInterval(function() {
                var newTimeUntilMidnight = calculateTimeUntilMidnight();
                setTimeLeft(formatTimeLeft(newTimeUntilMidnight));
                if (newTimeUntilMidnight <= 0) {
                    clearInterval(countdownInterval);
                }
            }, 1000);
        };
        scheduleMidnightFunction();
    }, []); // Empty dependency array to run effect only once on mount
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!qttr_tools_daypass_auth) {
            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                eventName: (props === null || props === void 0 ? void 0 : props.isQwaDashboard) ? "Prompted DayPass and Upgrade Plan Banner" : "Prompted Webflow Purchase Banner",
                payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                    label: (props === null || props === void 0 ? void 0 : props.isQwaDashboard) ? "Prompted DayPass and Upgrade Plan Banner" : "Prompted Webflow Purchase Banner",
                    component_name: _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .COMPONENT_NAMES.contentai_ai_tools */ .Xm.contentai_ai_tools,
                    screen_name: _constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .SCREEN_NAMES.contentai_ai_tools */ .iz.contentai_ai_tools
                }, props.toolMeta || {}), {
                    isQwaDashboard: props === null || props === void 0 ? void 0 : props.isQwaDashboard
                })
            });
            handleGetAllLinks();
        } else {
            // have day pass token but no usage left
            var searchParams = window.parent.location.search;
            var queryParams = new URLSearchParams(searchParams);
            var isBuyPass = queryParams.get("buyPass");
            handleGetAllLinks(isBuyPass ? false : true);
        }
    }, []);
    var launchDayPassPurchasePage = function(data) {
        var showExpired = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (data) {
            var urlsObj = {};
            var dayPassId = _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .DAY_PASS_PLAN_ID */ .kzQ;
            var dayPassObj = data.find(function(i) {
                return i.plan_id == dayPassId;
            });
            if (dayPassObj) {
                urlsObj["dayPass"] = dayPassObj === null || dayPassObj === void 0 ? void 0 : dayPassObj.link;
            }
            var dayPassLiteObj = data.find(function(i) {
                return i.plan_id == _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .DAY_PASS_LITE_PLAN_ID */ .xuj;
            });
            if (dayPassLiteObj) {
                urlsObj["dayPassLite"] = dayPassLiteObj === null || dayPassLiteObj === void 0 ? void 0 : dayPassLiteObj.link;
            }
            var toolsPlanLiteMonthlyObj = data.find(function(i) {
                return i.plan_id == _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .LITE_USD_MONTHLY */ .dVy;
            });
            if (toolsPlanLiteMonthlyObj) {
                urlsObj["toolsLiteUsdMonthly"] = toolsPlanLiteMonthlyObj === null || toolsPlanLiteMonthlyObj === void 0 ? void 0 : toolsPlanLiteMonthlyObj.link;
            }
            var toolsPlanProMonthlyObj = data.find(function(i) {
                return i.plan_id == _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .PRO_USD_MONTHLY */ .FIR;
            });
            if (toolsPlanProMonthlyObj) {
                urlsObj["toolsProUsdMonthly"] = toolsPlanProMonthlyObj.link;
            }
            var toolsPlanUltraMonthlyObj = data.find(function(i) {
                return i.plan_id == _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .ULTRA_USD_MONTHLY */ .PpB;
            });
            if (toolsPlanUltraMonthlyObj) {
                urlsObj["toolsUltraUsdMonthly"] = toolsPlanUltraMonthlyObj === null || toolsPlanUltraMonthlyObj === void 0 ? void 0 : toolsPlanUltraMonthlyObj.link;
            }
            var toolsIframeComponent = window.parent.document.querySelector('[qttr-id="Tools iframe"]');
            var webflowComponentWithToolsPurchaseAndDayPass = window.parent.document.querySelector('[qttr-id="Webflow Purchase Block"]');
            if (toolsIframeComponent && webflowComponentWithToolsPurchaseAndDayPass) {
                toolsIframeComponent.style.display = "none";
                webflowComponentWithToolsPurchaseAndDayPass.style.display = "flex";
                var dayPassBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[data-prop-label="Buy Day Pass"]');
                if (dayPassBtn && dayPassObj) {
                    dayPassBtn.href = dayPassObj === null || dayPassObj === void 0 ? void 0 : dayPassObj.link;
                }
                var litePlanBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Btn Buy AI Tools Lite Plan"]');
                if (litePlanBtn && toolsPlanLiteMonthlyObj) {
                    litePlanBtn.href = toolsPlanLiteMonthlyObj === null || toolsPlanLiteMonthlyObj === void 0 ? void 0 : toolsPlanLiteMonthlyObj.link;
                }
                var proPlanBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Btn Buy AI Tools Pro Plan"]');
                if (proPlanBtn && toolsPlanProMonthlyObj) {
                    proPlanBtn.href = toolsPlanProMonthlyObj === null || toolsPlanProMonthlyObj === void 0 ? void 0 : toolsPlanProMonthlyObj.link;
                }
                var ultraPlanBtn = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Btn Buy AI Tools Ultra Plan"]');
                if (ultraPlanBtn && toolsPlanUltraMonthlyObj) {
                    ultraPlanBtn.href = toolsPlanUltraMonthlyObj === null || toolsPlanUltraMonthlyObj === void 0 ? void 0 : toolsPlanUltraMonthlyObj.link;
                }
                var lockedOptionText = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Lock Option"]');
                var thankYouForVerifying = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Verification Complete Heading"]');
                var maxUsageLimitMsg = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Usage Limit Reached"]');
                var verificationCompleteBody = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Verification Complete Body"]');
                var planExpiredMessage = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Day Pass Expired"]');
                var emailSetting = webflowComponentWithToolsPurchaseAndDayPass.querySelector('[qttr-id="Usage Limit Reached email settings"]');
                var goBackAndContinueElements = webflowComponentWithToolsPurchaseAndDayPass === null || webflowComponentWithToolsPurchaseAndDayPass === void 0 ? void 0 : webflowComponentWithToolsPurchaseAndDayPass.querySelectorAll('[qttr-id="Go back & continue"]');
                if (goBackAndContinueElements) {
                    goBackAndContinueElements.forEach(function(element) {
                        var span = element.querySelector("span");
                        if (span && !span.getAttribute("data-event-attached")) {
                            span.addEventListener("click", function() {
                                webflowComponentWithToolsPurchaseAndDayPass.style.display = "none";
                                toolsIframeComponent.style.display = "block";
                                props === null || props === void 0 ? void 0 : props.handleWait();
                                (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                    eventName: "Clicked on Go back & Continue",
                                    payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                        label: "Clicked on Go back & Continue"
                                    }, props.toolMeta || {})
                                });
                            });
                            // Mark the span as having an event listener attached
                            span.setAttribute("data-event-attached", "true");
                        }
                    });
                }
                if ((props === null || props === void 0 ? void 0 : props.isRedirectToWebflow) && goBackAndContinueElements) {
                    if (lockedOptionText) {
                        lockedOptionText.style.display = "none";
                    }
                    if (planExpiredMessage) {
                        planExpiredMessage.style.display = "none";
                    }
                    if (maxUsageLimitMsg) {
                        maxUsageLimitMsg.style.display = "none";
                    }
                    if (emailSetting) {
                        emailSetting.style.display = "none";
                    }
                    goBackAndContinueElements.forEach(function(element) {
                        element.style.display = "block";
                    });
                } else {
                    if (goBackAndContinueElements && goBackAndContinueElements[1]) {
                        goBackAndContinueElements[1].style.display = "none";
                    }
                }
                if (lockedOptionText && props.isFromUnlockOption) {
                    // if clicked on locked option
                    (lockedOptionText).style.display = "flex";
                    if (planExpiredMessage) {
                        planExpiredMessage.style.display = "none";
                    }
                    if (maxUsageLimitMsg) {
                        maxUsageLimitMsg.style.display = "none";
                    }
                    if (emailSetting) {
                        emailSetting.style.display = "none";
                    }
                    if (goBackAndContinueElements && goBackAndContinueElements[1]) {
                        goBackAndContinueElements[1].style.display = "none";
                    }
                }
                if ((props === null || props === void 0 ? void 0 : props.verifiedEmailHere) && !(props === null || props === void 0 ? void 0 : props.isFromUnlockOption)) {
                    //after email verification not showing default popup messages if all limits exost
                    if (webflowComponentWithToolsPurchaseAndDayPass && toolsIframeComponent) {
                        webflowComponentWithToolsPurchaseAndDayPass.style.display = "none";
                        toolsIframeComponent.style.display = "block";
                        props === null || props === void 0 ? void 0 : props.handleWait();
                    }
                } else {
                    if (thankYouForVerifying) {
                        thankYouForVerifying.style.display = "none";
                    }
                    if (verificationCompleteBody) {
                        verificationCompleteBody.style.display = "none";
                    }
                    if (emailSetting) {
                        emailSetting.style.display = "none";
                    }
                }
                if (maxUsageLimitMsg && !props.verifiedEmailHere && qttr_tools_auth && props.isReachedMaxLimit) {
                    //for max usage limit reached.
                    (maxUsageLimitMsg).style.display = "flex";
                    if (emailSetting) {
                        emailSetting.style.display = "flex";
                    }
                    if (lockedOptionText) {
                        lockedOptionText.style.display = "none";
                    }
                    if (planExpiredMessage) {
                        planExpiredMessage.style.display = "none";
                    }
                }
                if (planExpiredMessage && showExpired) {
                    //for daypass expired message
                    (planExpiredMessage).style.display = "flex";
                    if (lockedOptionText) {
                        lockedOptionText.style.display = "none";
                    }
                    if (verificationCompleteBody) {
                        verificationCompleteBody.style.display = "none";
                    }
                    if (thankYouForVerifying) {
                        thankYouForVerifying.style.display = "none";
                    }
                    if (maxUsageLimitMsg) {
                        maxUsageLimitMsg.style.display = "none";
                    }
                    if (emailSetting) {
                        emailSetting.style.display = "none";
                    }
                }
            } else {
                setNativeModel(true);
            }
            console.log("set all elements");
        // window.parent.postMessage({ action: 'prompt_day_pass_plans', urls: urlsObj }, '*');
        }
    };
    var sendSlackMessageIfFails = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error, email) {
            var isPlainObject, fields, payload, payload1;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        isPlainObject = function(obj) {
                            return Object.prototype.toString.call(obj) === "[object Object]";
                        };
                        fields = [
                            {
                                title: "Error Message",
                                value: error.message || "Unknown error",
                                short: false
                            },
                            {
                                title: "Stack Trace",
                                value: "```".concat(error.stack || "No stack trace available", "```"),
                                short: false
                            },
                            {
                                title: "User Email",
                                value: email || "No email provided",
                                short: false
                            }, 
                        ];
                        if (error.response) {
                            fields.push({
                                title: "Response Status",
                                value: "".concat(error.response.status),
                                short: true
                            });
                            if (isPlainObject(error.response.data)) {
                                fields.push({
                                    title: "Response Data",
                                    value: "```".concat(JSON.stringify(error.response.data, null, 2), "```"),
                                    short: false
                                });
                            } else if (typeof error.response.data === "string" && !error.response.data.startsWith("<")) {
                                fields.push({
                                    title: "Response Data",
                                    value: "```".concat(error.response.data, "```"),
                                    short: false
                                });
                            }
                        } else if (error.request) {
                            fields.push({
                                title: "Request",
                                value: "```".concat(JSON.stringify(error.request, null, 2), "```"),
                                short: false
                            });
                        }
                        payload = {
                            text: "Error getting tools daypass plans and checkout links :: method => handleGetAllLinks",
                            attachments: [
                                {
                                    color: "danger",
                                    fields: fields
                                }, 
                            ]
                        };
                        _ctx.next = 7;
                        return axios__WEBPACK_IMPORTED_MODULE_22__/* ["default"].post */ .Z.post("/api/post_slack_message", {
                            payload: payload
                        });
                    case 7:
                        _ctx.next = 15;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        payload1 = {
                            text: "Error sending slack message on get all daypass link fail",
                            attachments: [
                                {
                                    color: "danger",
                                    fields: [
                                        {
                                            title: "Error Message",
                                            value: _ctx.t0.message || "Unknown error",
                                            short: false
                                        }, 
                                    ]
                                }, 
                            ]
                        };
                        console.error("Error :: sending slack message on get all daypass link fail :: ".concat(_ctx.t0));
                        _ctx.next = 15;
                        return axios__WEBPACK_IMPORTED_MODULE_22__/* ["default"].post */ .Z.post("/api/post_slack_message", {
                            payload: payload1
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function sendSlackMessageIfFails(error, email) {
            return _ref.apply(this, arguments);
        };
    }();
    var sanitizeBase64String = function(base64String) {
        return base64String.replace(/[^A-Za-z0-9+/=]/g, "");
    };
    var decodeBase64 = function(encodedString) {
        try {
            return JSON.parse(atob(encodedString));
        } catch (error) {
            console.error("Error decoding base64:", error);
            return null;
        }
    };
    var getPayloadBody = function(email, firstName, lastName) {
        var isRedirectToWebflow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        return {
            email: email,
            firstName: firstName,
            lastName: lastName,
            redirect_url: "".concat(window.parent.location.origin).concat(window.parent.location.pathname),
            tools_plan_redirect_url: "".concat(window.parent.location.origin, "/get-started?tab=ai-tools"),
            isRedirectToWebflow: isRedirectToWebflow
        };
    };
    var handleGetAllLinks = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var showExpired, cookieEmail, qttr_tools_auth, ref, ref1, payloadBody, ref2, ref3, ref4, ref5, ref6, ref7, headerEncoded, payloadEncoded, sanitizedPayloadEncoded, payload, res, dayPassLinksFiltered, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, _args = arguments;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        showExpired = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        cookieEmail = "";
                        _ctx.prev = 2;
                        qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_auth");
                        if (!(qttr_tools_auth || session || props.isRedirectToWebflow)) {
                            _ctx.next = 18;
                            break;
                        }
                        ;
                        if (!(allPlanLinks === null || allPlanLinks === void 0 ? void 0 : allPlanLinks.length)) {
                            _ctx.next = 9;
                            break;
                        }
                        launchDayPassPurchasePage(allPlanLinks, showExpired);
                        return _ctx.abrupt("return");
                    case 9:
                        payloadBody = {};
                        if (session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.email) {
                            ;
                            payloadBody = getPayloadBody(session.user.email, ((ref2 = session.user.name) === null || ref2 === void 0 ? void 0 : ref2.split(" ")[0]) || "", ((ref3 = session.user.name) === null || ref3 === void 0 ? void 0 : ref3.split(" ")[((ref6 = session === null || session === void 0 ? void 0 : (ref4 = session.user) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.name) === null || ref5 === void 0 ? void 0 : ref5.split(" ")) === null || ref6 === void 0 ? void 0 : ref6.length) - 1]) || "");
                        } else if (qttr_tools_auth && !(session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email)) {
                            ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((qttr_tools_auth === null || qttr_tools_auth === void 0 ? void 0 : qttr_tools_auth.split(".")) || [], 2), headerEncoded = ref7[0], payloadEncoded = ref7[1];
                            sanitizedPayloadEncoded = sanitizeBase64String(payloadEncoded);
                            payload = decodeBase64(sanitizedPayloadEncoded);
                            if (payload) {
                                cookieEmail = payload === null || payload === void 0 ? void 0 : payload.email;
                                payloadBody = getPayloadBody((payload === null || payload === void 0 ? void 0 : payload.email) || "", (payload === null || payload === void 0 ? void 0 : payload.firstName) || "", (payload === null || payload === void 0 ? void 0 : payload.lastName) || "");
                            } else {
                                payloadBody = getPayloadBody("", "", "", true);
                            }
                        } else {
                            payloadBody = getPayloadBody("", "", "", true);
                        }
                        _ctx.next = 13;
                        return axios__WEBPACK_IMPORTED_MODULE_22__/* ["default"].post */ .Z.post("/api/join-content-ai/get-tool-plans-links", payloadBody, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 13:
                        res = _ctx.sent;
                        setAllPlanLinks(res.data.data);
                        dayPassLinksFiltered = res.data.data.filter(function(item) {
                            return item.plan_id.includes("Day-Pass-Lite");
                        });
                        setDayPassLink(dayPassLinksFiltered === null || dayPassLinksFiltered === void 0 ? void 0 : dayPassLinksFiltered[0]);
                        launchDayPassPurchasePage(res.data.data, showExpired);
                    case 18:
                        _ctx.next = 31;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        console.error("handleGetCheckoutPage", _ctx.t0);
                        if (!([
                            403,
                            401
                        ].includes(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref8 = _ctx.t0.response) === null || ref8 === void 0 ? void 0 : ref8.status) && [
                            "Requires Authentication",
                            "Access Denied!!!"
                        ].includes(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref9 = _ctx.t0.response) === null || ref9 === void 0 ? void 0 : ref9.data))) {
                            _ctx.next = 30;
                            break;
                        }
                        _ctx.next = 27;
                        return (0,_utility_services_authActions__WEBPACK_IMPORTED_MODULE_16__.signOut)({
                            callbackUrl: "/login",
                            redirect: true
                        });
                    case 27:
                        (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                            eventName: "Logged out due to session expiry",
                            payload: {
                                label: "Logged out due to session expiry",
                                methodCalled: "getCreditsRemaining::tools"
                            }
                        });
                        _ctx.next = 31;
                        break;
                    case 30:
                        {
                            ;
                            sendSlackMessageIfFails(_ctx.t0, (session === null || session === void 0 ? void 0 : (ref10 = session.user) === null || ref10 === void 0 ? void 0 : ref10.email) ? session.user.email : cookieEmail ? cookieEmail : "");
                            ;
                            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                eventName: "Encountered Error While Fetching Checkout Page Link",
                                payload: {
                                    label: "Encountered Error While Fetching Checkout Page Link",
                                    email: (session === null || session === void 0 ? void 0 : session.user) ? session.user.email : cookieEmail ? cookieEmail : "",
                                    isQwaDashboard: props === null || props === void 0 ? void 0 : props.isQwaDashboard,
                                    errorMsg: (ref15 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref11 = _ctx.t0.response) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.errorMsg) !== null && ref15 !== void 0 ? ref15 : "Error Fetching Checkout links",
                                    errorData: (ref16 = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref13 = _ctx.t0.response) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.data) === null || ref14 === void 0 ? void 0 : ref14.data) !== null && ref16 !== void 0 ? ref16 : "Error Fetching Checkout links",
                                    error: _ctx.t0
                                }
                            });
                        }
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    20
                ]
            ]);
        }));
        return function handleGetAllLinks() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!nativeModel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_8__/* .QuattrLogoSpinner */ .h, {
            classes: {}
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (props === null || props === void 0 ? void 0 : props.isQwaDashboard) ? questionStyles.qwaFormWrapper : "",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: questionStyles.questionsWrapper,
                style: {
                    background: "#F6F7F9"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        style: {
                            position: "relative",
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                            style: {
                                fontFamily: "poppins",
                                fontSize: "18px",
                                color: "#F25F5C",
                                fontWeight: 700,
                                maxWidth: "450px"
                            },
                            children: (props === null || props === void 0 ? void 0 : props.showMinimumCreditsNeededMsg) ? "Oops.. You do not have the minimum credits needed to generate output" : !(session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.planId) || !qttr_tools_daypass_auth ? "You have reached your maximum usage limit" : "You have consumed your daily credits"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        style: {
                            maxWidth: "620px",
                            fontSize: "14px"
                        },
                        children: [
                            "You can either purchase more credits via a Day Pass or Upgrade to a plan with higher daily credit limits.",
                            " "
                        ]
                    }),
                    dayPassLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            maxWidth: "640px",
                            margin: "auto",
                            gap: "10px",
                            flexDirection: isMobile ? "column" : "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                fullWidth: true,
                                variant: "contained",
                                color: "primary",
                                disabled: showRequestLoader,
                                className: "".concat(signupStyles.signUpButton, " ").concat(signupStyles.dynamicWidthBtn, " ").concat(signupStyles.largeCTA, " ").concat(buyStyles.buyPassNow),
                                onClick: function() {
                                    (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                        eventName: "ButtonClick - Buy Day Pass",
                                        payload: {
                                            label: "ButtonClick - Buy Day Pass"
                                        }
                                    });
                                    window.location.href = dayPassLink === null || dayPassLink === void 0 ? void 0 : dayPassLink.link;
                                },
                                style: {
                                    padding: "43px 10px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            style: {
                                                fontSize: "18px",
                                                fontWeight: "700",
                                                color: "#1D3557"
                                            },
                                            children: [
                                                showRequestLoader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                    version: "1.1",
                                                    id: "loader",
                                                    style: {
                                                        fill: "#1D3557"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            id: "one",
                                                            d: "M5,25H0V0h5V25z"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            id: "two",
                                                            d: "M15,25h-5V0h5V25z"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            id: "three",
                                                            d: "M25,25h-5V0h5V25z"
                                                        })
                                                    ]
                                                }) : null,
                                                showRequestLoader ? "Please wait..." : props.isSubscriptionExpired ? "Buy $0.99 USD Day Pass Again" : "Buy $0.99 USD Day Pass",
                                                !showRequestLoader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                    children: "#"
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            style: {
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#1D3557"
                                            },
                                            children: [
                                                "Get 20 Additional Credits",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                    children: "*"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                fullWidth: true,
                                variant: "contained",
                                color: "primary",
                                disabled: showRequestLoader,
                                className: "".concat(signupStyles.signUpButton, " ").concat(signupStyles.dynamicWidthBtn, " ").concat(signupStyles.largeCTA, " ").concat(buyStyles.buyPassNow),
                                onClick: function() {
                                    (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                        eventName: "ButtonClick - Upgrade Plan",
                                        payload: {
                                            label: "ButtonClick - Upgrade Plan",
                                            isQwaDashboard: props === null || props === void 0 ? void 0 : props.isQwaDashboard
                                        }
                                    });
                                    router.push("/app/add-credits");
                                },
                                style: {
                                    padding: "43px 10px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            style: {
                                                fontSize: "18px",
                                                fontWeight: "700",
                                                color: "#1D3557"
                                            },
                                            children: [
                                                showRequestLoader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                    version: "1.1",
                                                    id: "loader",
                                                    style: {
                                                        fill: "#1D3557"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            id: "one",
                                                            d: "M5,25H0V0h5V25z"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            id: "two",
                                                            d: "M15,25h-5V0h5V25z"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                            id: "three",
                                                            d: "M25,25h-5V0h5V25z"
                                                        })
                                                    ]
                                                }) : null,
                                                showRequestLoader ? "Please wait..." : "Upgrade Plan"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                            style: {
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#1D3557"
                                            },
                                            children: "Get more daily credits"
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                        fullWidth: true,
                        variant: "contained",
                        color: "primary",
                        disabled: showRequestLoader,
                        className: "".concat(signupStyles.signUpButton, " ").concat(signupStyles.dynamicWidthBtn, " ").concat(signupStyles.largeCTA, " ").concat(buyStyles.buyPassNow),
                        onClick: function() {
                            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                eventName: "ButtonClick - Upgrade Plan",
                                payload: {
                                    label: "ButtonClick - Upgrade Plan",
                                    isQwaDashboard: props === null || props === void 0 ? void 0 : props.isQwaDashboard
                                }
                            });
                            router.push("/app/add-credits");
                        },
                        style: {
                            padding: "43px 10px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                    style: {
                                        fontSize: "18px",
                                        fontWeight: "700",
                                        color: "#1D3557"
                                    },
                                    children: [
                                        showRequestLoader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                            version: "1.1",
                                            id: "loader",
                                            style: {
                                                fill: "#1D3557"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                    id: "one",
                                                    d: "M5,25H0V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                    id: "two",
                                                    d: "M15,25h-5V0h5V25z"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                    id: "three",
                                                    d: "M25,25h-5V0h5V25z"
                                                })
                                            ]
                                        }) : null,
                                        showRequestLoader ? "Please wait..." : "Upgrade Plan"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                    style: {
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#1D3557"
                                    },
                                    children: "Get more daily credits"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.conditions,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                children: "#"
                            }),
                            "One day pass is valid for 24 hours. No auto-renewal.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "*Fair usage policy applies. Read",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                style: {
                                    cursor: "pointer",
                                    textDecoration: "underline"
                                },
                                onClick: function() {
                                    window.open("/content-ai/terms");
                                },
                                children: [
                                    "terms of use",
                                    " "
                                ]
                            }),
                            " ",
                            "for more."
                        ]
                    }),
                    (session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.planId) && !qttr_tools_daypass_auth ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                component: "h4",
                                className: buyStyles.dividerTextOr,
                                children: "OR"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                component: "h4",
                                className: buyStyles.dividerTextDescription,
                                children: [
                                    "Wait for ",
                                    timeLeft,
                                    " until your credits reset."
                                ]
                            })
                        ]
                    }) : !(session === null || session === void 0 ? void 0 : (ref2 = session.user) === null || ref2 === void 0 ? void 0 : ref2.planId) && !qttr_tools_daypass_auth ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                component: "h4",
                                className: buyStyles.dividerTextOr,
                                children: "OR"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                component: "h4",
                                className: buyStyles.dividerTextDescription,
                                children: "Wait for the next 8 hours until your credits reset."
                            })
                        ]
                    }) : null
                ]
            }),
            props.isSubscriptionExpired ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                onClick: function() {
                    if (props.handleContinue) {
                        props.handleContinue();
                    }
                    (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                        eventName: "Clicked on Continue",
                        payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                            label: "Clicked on Continue"
                        }, props.toolMeta || {})
                    });
                },
                className: buyStyles.willGet,
                style: {
                    cursor: "pointer",
                    fontSize: "12px",
                    marginTop: "20px"
                },
                children: "OR Get 7 credits every 8 hours for free. Best for occasional use."
            }) : null,
            !isDirectBuyPassPage && !props.isFromUnlockOption && props.verifiedEmailHere && props.handleWait && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.orWait,
                        children: "OR Access Tools for Free with Usage Limits"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.willGet,
                        children: [
                            "For a limited time, verified accounts get 7 credits every 8 hours for free. ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "Generate up to 7 credits for free, then wait 8 hours before you can use more. ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            " This waiting period ensures fair access to our tools for all users."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        onClick: function() {
                            if (props.handleWait) {
                                props.handleWait();
                            }
                            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                eventName: "Clicked on Continue",
                                payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                    label: "Clicked on Continue"
                                }, props.toolMeta || {})
                            });
                        },
                        className: buyStyles.orWait,
                        style: {
                            cursor: "pointer",
                            fontSize: "12px",
                            marginTop: "20px",
                            textDecoration: "underline"
                        },
                        children: "Continue"
                    })
                ]
            })
        ]
    });
};
var BuyOnePassSuccess = function(param) {
    var handleContinue = param.handleContinue, toolMeta = param.toolMeta, _isQwaDashboard = param.isQwaDashboard, isQwaDashboard = _isQwaDashboard === void 0 ? false : _isQwaDashboard;
    var formatDate = function formatDate(dateString) {
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        var date = new Date(dateString);
        var day = date.getDate();
        var month = months[date.getMonth()];
        var year = date.getFullYear();
        var hours = date.getHours().toString().padStart(2, "0");
        var minutes = date.getMinutes().toString().padStart(2, "0");
        return "".concat(day, "-").concat(month, "-").concat(year, " ").concat(hours, ":").concat(minutes);
    };
    var questionStyles = (0,_DescribeQuestion__WEBPACK_IMPORTED_MODULE_2__/* .useQuestionsStyles */ .b)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showRequestLoader = ref[0], setShowRequestLoader = ref[1];
    var session = (0,_utility_services_customHooks__WEBPACK_IMPORTED_MODULE_13__/* .useSession */ .kP)().session;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), dayPassPurchaseVerified = ref1[0], setDayPassPurchaseVerified = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isSubscriptionExpired = ref2[0], setIsSubscriptionExpired = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), verificationFailed = ref3[0], setVerificationFailed = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), validTillDate = ref4[0], setValidTillDate = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), plan_id = ref5[0], setPlanId = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), tz = ref6[0], setTz = ref6[1];
    var buyStyles = useBuyStyles();
    var isMobile = (0,_utility_services_uiHelpers__WEBPACK_IMPORTED_MODULE_10__/* .useView */ .Pl)("mobileOnly", true);
    var getTimeZone = function() {
        var timezone = moment_timezone__WEBPACK_IMPORTED_MODULE_7___default().tz.guess(); // Guess the user's time zone
        var time = moment_timezone__WEBPACK_IMPORTED_MODULE_7___default().tz(new Date(), timezone); // Create a moment object with the user's timezone
        return time.format("z"); // Prints the timezone abbreviation, such as IST
    };
    var VerifyUserPurchase = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(planId) {
            var qttr_tools_auth, ref, ref1, ref2, timezone, payloadBody, ref3, headerEncoded, payloadEncoded, signatureEncoded, payload, ref4, ref5, res, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
            return _home_node_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_auth");
                        if (!(qttr_tools_auth || session)) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        setShowRequestLoader(true);
                        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        payloadBody = {};
                        if (qttr_tools_auth) {
                            ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(qttr_tools_auth.split("."), 3), headerEncoded = ref3[0], payloadEncoded = ref3[1], signatureEncoded = ref3[2];
                            payload = JSON.parse(atob(payloadEncoded));
                            payloadBody = {
                                email: payload.email,
                                firstName: payload.firstName,
                                lastName: payload.lastName,
                                timezone: timezone,
                                plan_id: planId,
                                isQwaDashboard: isQwaDashboard
                            };
                        } else {
                            ;
                            payloadBody = {
                                email: session === null || session === void 0 ? void 0 : session.user.email,
                                firstName: ((ref4 = session === null || session === void 0 ? void 0 : session.user.name) === null || ref4 === void 0 ? void 0 : ref4.split(" ")[0]) || "",
                                lastName: ((ref5 = session === null || session === void 0 ? void 0 : session.user.name) === null || ref5 === void 0 ? void 0 : ref5.split(" ")[1]) || "",
                                timezone: timezone,
                                plan_id: planId,
                                isQwaDashboard: isQwaDashboard
                            };
                        }
                        _ctx.next = 10;
                        return axios__WEBPACK_IMPORTED_MODULE_22__/* ["default"].post */ .Z.post("/api/join-content-ai/verify-day-pass-purchased", payloadBody, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        });
                    case 10:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.data) && (res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.id)) {
                            if (!dayPassPurchaseVerified) {
                                ;
                                setDayPassPurchaseVerified(true);
                                setValidTillDate(formatDate(res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.data.expires_at));
                                setPlanId(planId);
                                (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                    eventName: "Purchase Verified (".concat(res === null || res === void 0 ? void 0 : (ref7 = res.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.description, ") & Activated Successfully"),
                                    payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                        plan_id: planId,
                                        label: "Purchase Verified (".concat(res === null || res === void 0 ? void 0 : (ref9 = res.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : ref10.description, ") & Activated Successfully")
                                    }, toolMeta || {})
                                });
                                (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                    eventName: "Revenue tracking - DayPass",
                                    payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                        isQwaDashboard: isQwaDashboard,
                                        userDetails: payloadBody,
                                        plan_id: planId,
                                        $productId: planId,
                                        $price: (res === null || res === void 0 ? void 0 : (ref11 = res.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.amount) / 100,
                                        $revenue: (res === null || res === void 0 ? void 0 : (ref13 = res.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.data) === null || ref14 === void 0 ? void 0 : ref14.amount) / 100,
                                        $currency: "USD",
                                        $revenueType: "DayPass",
                                        validTillDate: (0,_utility_common__WEBPACK_IMPORTED_MODULE_12__/* .formatToEnUsDate */ .Cgj)(res === null || res === void 0 ? void 0 : (ref15 = res.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : ref16.expires_at),
                                        datePurchased: (0,_utility_common__WEBPACK_IMPORTED_MODULE_12__/* .formatUnixDate */ .WEC)(res === null || res === void 0 ? void 0 : (ref17 = res.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.purchaseDateInSeconds),
                                        label: "Revenue tracking - DayPass Purchase"
                                    }, toolMeta || {})
                                });
                            }
                        }
                    case 12:
                        _ctx.next = 20;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        if (typeof (0,lodash__WEBPACK_IMPORTED_MODULE_9__.get)(_ctx.t0, "response.data.data") === "string" && ((ref19 = (0,lodash__WEBPACK_IMPORTED_MODULE_9__.get)(_ctx.t0, "response.data.data")) === null || ref19 === void 0 ? void 0 : ref19.includes("Expired"))) {
                            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                eventName: "Prompted As: Your Day Plan has Expired!",
                                payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                    label: "Prompted As: Your Day Plan has Expired!"
                                }, toolMeta || {})
                            });
                            setIsSubscriptionExpired(true);
                        } else {
                            setVerificationFailed(true);
                            (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                eventName: "Prompted As: Something Went Wrong!",
                                payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                    label: "Prompted As: Something Went Wrong!",
                                    error: (0,lodash__WEBPACK_IMPORTED_MODULE_9__.get)(_ctx.t0, "response.data.data")
                                }, toolMeta || {})
                            });
                        }
                        setShowRequestLoader(false);
                        console.error("VerifyUserPurchase::", _ctx.t0);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }));
        return function VerifyUserPurchase(planId) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var timeoutId;
        var searchParams = window.parent.location.search;
        var qttr_tools_auth = js_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("qttr_tools_auth");
        if (!searchParams) {
            timeoutId = setTimeout(function() {
                var searchParams = window.parent.location.search;
                var queryParams = new URLSearchParams(searchParams);
                var planId = queryParams.get("plan_id");
                if (qttr_tools_auth || session) {
                    VerifyUserPurchase(planId);
                // handleGetCheckoutPage();
                }
            }, 500);
        }
        var queryParams = new URLSearchParams(searchParams);
        var planId = queryParams.get("plan_id");
        if (qttr_tools_auth || session) {
            VerifyUserPurchase(planId);
        // handleGetCheckoutPage();
        }
        var timezone = getTimeZone();
        if (timezone) {
            setTz(timezone);
        }
    }, [
        session
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var Iframe = window.parent.document.querySelector('[qttr-id="quattrai-tools-frame"]');
        if (isMobile && Iframe) {
            Iframe.scrollIntoView();
            window.parent.scrollBy(0, -100);
        }
    }, [
        isMobile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        return function() {
            setDayPassPurchaseVerified(false);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        id: "day-pass-last-step",
        className: isQwaDashboard ? buyStyles.finalStepWrapper : "",
        children: !dayPassPurchaseVerified && !(isSubscriptionExpired || verificationFailed) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_QuattrLogoSpinner__WEBPACK_IMPORTED_MODULE_8__/* .QuattrLogoSpinner */ .h, {
                    classes: {}
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                    className: buyStyles.buyBoxOuterHeader,
                    children: [
                        "Please wait & do not refresh screen.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        "We are activating your day pass & ensuring you enjoy all its perks."
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: isSubscriptionExpired ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.buyBoxOuterHeader,
                        style: {
                            fontSize: "28px"
                        },
                        children: "Your Day Plan has Expired!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BuyOnePass, {
                        isSubscriptionExpired: true,
                        handleContinue: handleContinue
                    })
                ]
            }) : verificationFailed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.buyBoxOuterHeader,
                        style: {
                            fontSize: "28px",
                            color: "#F25F5C"
                        },
                        children: "Oops.. Something Went Wrong!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.buyBoxOuterHeader,
                        style: {
                            fontSize: "20px"
                        },
                        children: "Please refresh your screen to retry the Day Pass setup."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.conditions,
                        children: [
                            "Still not working? Please contact us at ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("u", {
                                children: " support@quattr.com "
                            }),
                            " & we will resolve it asap."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: buyStyles.buyPassSuccessWrapper,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        src: "https://qwa-assets.s3.us-east-2.amazonaws.com/success_blast.svg",
                        alt: "celebrate",
                        className: buyStyles.celebrateImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.buyBoxOuterHeader,
                        style: {
                            fontSize: "28px"
                        },
                        children: [
                            "Your ",
                            plan_id == _utility_common__WEBPACK_IMPORTED_MODULE_12__/* .DAY_PASS_LITE_PLAN_ID */ .xuj ? "Day Pass" : "Day Pass",
                            " is Activated Successfully!"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        className: buyStyles.buyBoxOuterHeader,
                        children: [
                            "Valid till ",
                            validTillDate || "DD-Mon-YYYY HR:MM",
                            " ",
                            tz || ""
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "center-align ".concat(buyStyles.successActionBox),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                className: buyStyles.buyBoxOuterHeader,
                                style: {
                                    fontSize: "18px"
                                },
                                children: "You can now enjoy the perks of your pass on Quattr AI Tools*."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                className: buyStyles.conditions,
                                children: [
                                    "*Fair usage policy applies. Read",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        style: {
                                            textDecorationLine: "underline",
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            // window.parent.postMessage({ action: 'redirectURL', url: '/content-ai/terms', newTab: true }, '*');
                                            window.open("/content-ai/terms");
                                        },
                                        children: "terms of use"
                                    }),
                                    " ",
                                    "for more."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                onClick: function() {
                                    (0,_constants_analyticsMeta__WEBPACK_IMPORTED_MODULE_11__/* .trackAnalyticsEvent */ .ec)({
                                        eventName: "Clicked on Close & Continue",
                                        payload: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                                            label: "Clicked on Close & Continue"
                                        }, toolMeta || {})
                                    });
                                    if (handleContinue) {
                                        handleContinue();
                                    }
                                },
                                style: isMobile ? {
                                    width: "100%"
                                } : {
                                    minWidth: "500px"
                                },
                                className: "".concat(questionStyles.buttonOption, " mt-15"),
                                children: "Close & Continue"
                            })
                        ]
                    })
                ]
            })
        })
    });
};


/***/ })

}]);